import Link from 'next/link'
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function HelpFAQ() {
  return (
    <div className="flex flex-col items-center justify-end pt-8 lg:pt-16 xl:pt-20 px-10">
      <div className="shadow-2xl p-10 border border-gray-200 rounded-t-lg w-full md:w-4/5 xl:w-3/5">
        <h3 className="text-4xl font-semibold text-gray-800 pt-2 pb-6">
          {`Help & FAQ`}
        </h3>

        <Link
          target="_blank"
          href="https://guide.upstreamapp.com/getting-started/understanding-daos"
        >
          <div className="border-b border-gray-200 pb-6 mt-6 flex justify-between items-center cursor-pointer group">
            <p className="text-xl text-gray-500 group-hover:text-gray-700 font-light">
              What is a DAO?
            </p>
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-gray-300 group-hover:text-gray-800"
            />
          </div>
        </Link>

        <Link
          target="_blank"
          href="https://guide.upstreamapp.com/getting-started/understanding-daos"
        >
          <div className="border-b border-gray-200 pb-6 mt-6 flex justify-between items-center cursor-pointer group">
            <p className="text-xl text-gray-500 group-hover:text-gray-800 font-light">
              What are the benefits of DAOs?
            </p>
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-gray-300 group-hover:text-gray-800"
            />
          </div>
        </Link>

        <Link target="_blank" href="https://guide.upstreamapp.com">
          <div className="border-b border-gray-200 pb-6 mt-6 flex justify-between items-center cursor-pointer group">
            <p className="text-xl text-gray-500 group-hover:text-gray-800 font-light">
              View All
            </p>
            <FontAwesomeIcon
              icon={faChevronRight}
              className="text-gray-300 group-hover:text-gray-800"
            />
          </div>
        </Link>
      </div>
    </div>
  )
}

export default HelpFAQ
